<button #triggerBtn
        class="bell-trigger"
        (click)="togglePanel()"
        [matTooltip]="collapsed() ? 'Notifications' : ''"
        matTooltipPosition="right"
        aria-label="Notifications">
  <div class="bell-icon-wrap">
    <mat-icon class="bell-icon">notifications</mat-icon>
    @if (unreadCount() > 0) {
      <span class="badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  </div>
  @if (!collapsed()) {
    <span class="bell-label">Notifications</span>
    @if (unreadCount() > 0) {
      <span class="count-pill">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  }
</button>

@if (open()) {
  <div class="notif-panel" [style.top.px]="panelTop()">
    <div class="notif-panel-header">
      <span class="notif-panel-title">Notifications</span>
      @if (unreadCount() > 0) {
        <button class="mark-all-btn" (click)="markAllRead()">Mark all read</button>
      }
    </div>

    @if (loading()) {
      <div class="notif-empty">Loading…</div>
    } @else if (notifications().length === 0) {
      <div class="notif-empty">No notifications yet</div>
    } @else {
      <ul class="notif-list">
        @for (n of notifications(); track n.id) {
          <li class="notif-item" [class.notif-item--unread]="!n.is_read" (click)="navigateTo(n)">
            @if (!n.is_read) { <span class="unread-dot"></span> }
            <div class="notif-body">
              <div class="notif-title">{{ n.title }}</div>
              <div class="notif-desc">{{ n.body }}</div>
              <div class="notif-time">{{ timeAgo(n.created_at) }}</div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
  <div class="notif-backdrop" (click)="togglePanel()"></div>
}
